export default __webpack_public_path__ + "static/media/latest-news-img10.3f8dbc76.jpg";